import React, { useState, useEffect, useRef  } from 'react';
import styled from "styled-components";
import { Container, Row, Col, Card, Carousel  } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from '../../firebase/firebase';
import CasdSkeleton from '../../components/CasdSkeleton';
import PriceInfoIcon from '../../components/PriceInfoIcon';

export default function UtvalgteProdukter() {
    const [products, setProducts] = useState([])
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [loading, setLoading] = useState(true)
    const scrollRef = useRef(null);

    


    useEffect(() => {
        const fetchFeaturedProducts = async () => {
            const q = query(
                collection(db, 'products'),  // Replace 'your_collection_name' with the actual collection name
                where('featured', '==', true),  // Filter to only include documents where 'isFeatured' is true
            );

            const querySnapshot = await getDocs(q);
            const fetchedProducts = querySnapshot.docs.map(doc => doc.data());
            setProducts(fetchedProducts);
            setLoading(false)
        };

        fetchFeaturedProducts();
    }, []);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
      };
      
      const handleMouseLeave = () => {
        setIsDragging(false);
      };
      
      const handleMouseUp = () => {
        setIsDragging(false);
      };
      
      const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX);
        scrollRef.current.scrollLeft = scrollLeft - walk;
      };
      

    return (
        <StyledDiv>
          <div className='container my-5'>
            <div className='wrapper'>
              <h3 className='p-2'>Populære produkter</h3>
              <div className="custom-carousel-container"
                ref={scrollRef}
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}>
                {loading && <> <CasdSkeleton/><CasdSkeleton/><CasdSkeleton/><CasdSkeleton/><CasdSkeleton/></> }
                {products.map((product, idx) => (
                  <div className="custom-carousel-item" key={idx}>
                    <StyledCard>
                      <StyledLink to={`/${product.breadcrumb1}/${product.breadcrumb2 || ''}/${product.breadcrumb3 || ''}/${product.productName}`}>
                        <Card className='card'>
                          <Card.Img variant="top" src={product.imageSrc} />
                          <Card.Body>
                            <Card.Title>{product.productName}</Card.Title>
                            <PriceUnitContainer>
                            <PriceInfoIcon infoText={"Alle priser er basert på ca. utsalgspriser fra de store byggevarekjedene."}/>
                              <PriceText>Kr {product.byggmakkerPrice}</PriceText>
                              <UnitText>{product.unit}</UnitText>
                            </PriceUnitContainer>
                            <Advantages>
                              {product.advantages.map((adv, idx) => <li key={idx}>{adv}</li>)}
                            </Advantages>
                          </Card.Body>
                        </Card>
                      </StyledLink>
                    </StyledCard>
                  </div>
            
                ))}
              </div>
            </div>
          </div>
        </StyledDiv>
      )
    
}

const StyledDiv = styled.div`

.card{
    height:365px ;
    overflow-y:hidden ;
}

.custom-carousel-container {
    display: flex;
    width: 100%;
    margin: 5px;
    padding: 15px;
    -ms-overflow-style: none;  /* for Internet Explorer, Edge */
  scrollbar-width: none;  /* for Firefox */
  overflow-x: scroll;  /* allow horizontal scroll */
  overflow-y: hidden;  /* hide vertical scroll */
}

.custom-carousel-container::-webkit-scrollbar {
  display: none;  /* for Chrome, Safari, and Opera */
}
  .custom-carousel-item {
    flex: 0 0 auto;
    width: 250px;
    margin-right: 10px;
  }

h3 {
    color: #2c3e50;
    border-bottom: 2px solid #ecf0f1;
    margin-left:10px;
  }
.container{
    padding:0;
}
  p{
    margin-left:13px;
  }

.wrapper{
   background-color: #ecf0f1;
   border-radius:10px ;
   overflow-x:hidden ;
   overflow-y:hidden ;

}



`;


const PriceUnitContainer = styled.div`
    display: flex;
    align-items: baseline;  // align items along the text baseline
`;

const PriceText = styled.span`
    font-size: 1.3em;
    font-weight: bold;
`;

const UnitText = styled.span`
    font-size: 1.1em;
    margin-left: 0.1em;  // Add a little spacing between the price and the unit
`;

const Advantages = styled.ul`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 17px; // space for bullet points
  font-size:12px;
`;

const StyledLink = styled(Link)`
  text-decoration: none; // Removes the underline
  color: inherit; // Inherits the color from its parent
`;

const StyledCard = styled.div`
  cursor: pointer;
  max-width: 250px; // set the maximum width of each card
  margin: auto; // centers the card within its container

  .card {
    &:hover {
      border: 1px solid gray;
      scale: 1.01;
    }
    .body {
      padding: 12px;
    }
    img {
      object-fit: cover;  // or use 'contain' based on your need
      height: 200px;  // set to the height you desire
      width: 100%; // auto-adjusts to keep aspect ratio
    }
  }
`;
